import {
    LOGIN_INITIALISE_SUCCESS,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
} from "../actions/types";

const user = JSON.parse(localStorage.getItem("user"));

const initialState = user
    ? { isLoggedIn: true, user }
    : { isLoggedIn: false, isAuthentificated: false, authnAttemptId: null, user: {} };

const AuthReducer =  (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case LOGIN_INITIALISE_SUCCESS:
            return {
                ...state,
                isAuthentificated: payload.isAuthentificated,
                authnAttemptId: payload.authnAttemptId,
                user: {},
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: payload.user,
            };
        case LOGIN_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: {},
            };
        case LOGOUT:
            return {
                ...state,
                isLoggedIn: false,
                isAuthentificated: false,
                authnAttemptId: null,
                user: {},
            };
        default:
            return state;
    }
}

export default AuthReducer;